import {
	Typography,
	List,
	ListItemButton,
	ListItemText,
	ListItemAvatar,
	ListItem,
	Avatar,
	Badge,
} from "@mui/material";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import useClickAndHold from "./ClickAndHold.js";

const StyledBadge = styled(Badge)(({ theme }) => ({
	"& .MuiBadge-badge": {
		backgroundColor: "#44b700",
		color: "#44b700",
		boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
		"&::after": {
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			borderRadius: "50%",
			animation: "ripple 1.2s infinite ease-in-out",
			border: "1px solid currentColor",
			content: '""',
		},
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(.8)",
			opacity: 1,
		},
		"100%": {
			transform: "scale(2.4)",
			opacity: 0,
		},
	},
}));

export function ClickAndHoldButton() {
	const handlers = useClickAndHold(() => {
		console.log("Held long enough!");
		alert("You held the button for 2s 🚀");
	}, 2000); // 2000ms = 2 seconds

	return (
		<button
			{...handlers}
			style={{
				padding: "1rem 2rem",
				fontSize: "1rem",
				borderRadius: "8px",
				cursor: "pointer",
			}}
		>
			Click and Hold
		</button>
	);
}

export function GenerateWeekDays({ selectedWeek }) {
	const weekdays = ["Mon", "Tue", "Wed", "Thur", "Fri", "Sat", "Sun"];
	const startOfWeek = getDateOfISOWeek(selectedWeek.week, selectedWeek.year);
	const today = new Date();

	return (
		<List>
			{weekdays.map((day, i) => {
				const dateOfInterest = new Date(startOfWeek);
				dateOfInterest.setDate(startOfWeek.getDate() + i);
				return generateWeekdayItem(day, i, dateOfInterest, today);
			})}
		</List>
	);
}

// Calculate the Monday of a given ISO week/year
export function getDateOfISOWeek(week, year) {
	const simple = new Date(year, 0, 1 + (week - 1) * 7);
	const dow = simple.getDay();
	const ISOweekStart = simple;
	if (dow <= 4) {
		ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
	} else {
		ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
	}
	return ISOweekStart;
}

export function generateWeekdayItem(day, i, dateOfInterest, today) {
	return (
		<ListItem key={i}>
			<ListItemAvatar
				sx={{
					minWidth: 40,
					mr: 1,
				}}
			>
				{today.toDateString() === dateOfInterest.toDateString() ? (
					<StyledBadge
						overlap="circular"
						anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
						variant="dot"
					>
						<Avatar>
							<Typography variant="overline">
								{dateOfInterest.getDate()}/{dateOfInterest.getMonth() + 1}
							</Typography>
						</Avatar>
					</StyledBadge>
				) : (
					<Avatar>
						<Typography variant="overline">
							{dateOfInterest.getDate()}/{dateOfInterest.getMonth() + 1}
						</Typography>
					</Avatar>
				)}
			</ListItemAvatar>
			<Typography variant="overline">{day}</Typography>
		</ListItem>
	);
}

export function GenerateMealItem({ item, index, replaceMeal }) {
	const [loading, setLoading] = useState(false);
	const [longPressed, setLongPressed] = useState(false);

	const handlers = useClickAndHold(async () => {
		setLoading(true);
		setLongPressed(true);
		try {
			const res = await fetch(
				"https://us-central1-mealplanner-f6b88.cloudfunctions.net/api/random-notion-page"
			);
			if (!res.ok) throw new Error("Failed to fetch random meal");
			const newMeal = await res.json();

			// update parent list
			setLoading(false);
			replaceMeal(index, newMeal);
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	}, 2000);

	const handleClick = (e) => {
		if (longPressed) {
			e.preventDefault(); // prevent navigation after long press
			setLongPressed(false); // reset for next interaction
			return;
		}
		// otherwise, normal navigation happens (href on ListItemButton)
	};

	return (
		<ListItem key={item.title} disablePadding className="scroll-container">
			<ListItemButton
				onClick={handleClick}
				{...handlers}
				sx={{
					userSelect: "none", // prevent text selection
					WebkitUserDrag: "none",
				}}
				component="a"
				href={item.externalUrl || item.notionUrl}
				target="_blank"
				rel="noopener noreferrer"
			>
				<ListItemAvatar
					sx={{
						minWidth: 40, // default is 56px — reduce it
						mr: 0.5, // reduce right margin (default is 2)
						bgcolor: "#fff",
					}}
				>
					<Avatar sx={{ bgcolor: "#fff" }}>{item.emoji || ""}</Avatar>
				</ListItemAvatar>
				<ListItemText
					sx={{
						whiteSpace: "nowrap",
						overflow: "auto",
						textOverflow: "ellipsis",
					}}
					primary={loading ? "Changing..." : item.title || ""}
				/>
			</ListItemButton>
		</ListItem>
	);
}

export async function getFullDB() {}
